import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import {
  getPatientReviewProfileRoleSegment,
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
} from '@brands/Utils/reviewProfileBasePath';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './styles.module.scss';

const MobileHandoffModal = (): JSX.Element => {
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const { userInfo } = useAppSelector(selectAuth);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const { state } = useLocation();
  const goToDashboard = useCallback(() => {
    const patientId = (state as { patientId?: number } | null)?.patientId;
    if (isStaffCaseCreationRole(userInfo.role.name) && patientId != null) {
      navigate(
        `${getStaffReviewProfileBasePath(userInfo.role.name)}/${getPatientReviewProfileRoleSegment(
          currentPatient,
        )}/${patientId}`,
      );
    } else {
      roleNavigate('/dashboard');
    }
  }, [userInfo.role.name, navigate, roleNavigate, state, currentPatient]);

  return (
    <div className="modalBackground" style={{ zIndex: '999' }} onClick={() => goToDashboard()}>
      <div className={`${styles.handoff_modal}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalCloseIcon}>
          <button type="button" onClick={() => goToDashboard()} aria-label="Close modal">
            <CloseIcon />
          </button>
        </div>
        <div className="body">
          <p>It looks like you’ve proceeded on your phone</p>
          <div className="modal-buttons" style={{ flexDirection: 'row', marginTop: 'auto' }}>
            <Button
              className={styles.handoffModalButton}
              variant="contained"
              type="button"
              onClick={() => goToDashboard()}
            >
              Return to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileHandoffModal;
